import { Component, Input, OnDestroy } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { Subject } from "rxjs";
import { filter, first, map, takeUntil } from "rxjs/operators";
import packageInfo from "../../../../package.json";
import { DialogService, DialogType } from "../services/dialog.service";
const version = packageInfo.version;
@Component({
  selector: "app-version",
  templateUrl: "./version.component.html",
  styleUrls: ["./version.component.scss"],
})
export class VersionComponent implements OnDestroy {
  @Input() alignment: string = "align-right";
  @Input() cssClass: string = "versionText-white";

  updateAvailable = false;
  version: string = version;
  constructor(
    private updates: SwUpdate,
    private _dialogService: DialogService
  ) {
    this.updateAvailable = sessionStorage.getItem("updateAvailable") == "true";

    updates.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === "VERSION_READY"),
        map((evt) => ({
          type: "UPDATE_AVAILABLE",
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))
      )
      .subscribe((evt) => {
        if (evt.current !== evt.available) this.updateAvailable = true;
      });
  }
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  promptUser(): boolean {
    this._dialogService
      .openDialog({
        headerText: $localize`:@@version.update.header:New version available!`,
        detailText: $localize`:@@version.update.message:There's a new version available. Please click the button below to load it. If you still have unsaved changes, you can also cancel, In that case, please save your changes and click on the version number to load the new version.`,
        dialogType: DialogType.Continue,
        fullscreen: true,
      })
      .pipe(first())
      .subscribe((feedback: boolean) => {
        if (feedback) this.updateVersion();
      });
    return true;
  }

  updateVersion() {
    this.updates.activateUpdate().then((succesfullUpdate) => {
      if (succesfullUpdate) {
        sessionStorage.setItem("updateAvailable", "false");
        this.updateAvailable = false;
        document.location.reload();
      }
    });
  }
}
